<template>
  <div class="accordion-order">
    <button
        @click="toggleAccordion()"
        class="accordion-order__button"
    >
      <slot name="title" />
      <svg
          class="accordion-order__icon-row"
          :class="{
          'rotate-180': isOpen,
          'rotate-0': !isOpen,
        }"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          width="9"
          height="5"
          viewBox="0 0 9 5"
          fill="none"
      >
        <path
            d="M8.67322 5L4.33658 0L-4.95911e-05 5H8.67322Z"
            fill="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="show-content"
        :class="isOpen ? 'active' : ''">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderRelatedAccordion",
  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
